export const UPDATE_SUBSCRIPTION = /* GraphQL */ `
    mutation updateCustomerV2($subscription_channels: String!) {
        updateCustomerV2(
            input: { subscription_channels: $subscription_channels }
        ) {
            customer {
                subscription_channels
            }
        }
    }
`
